// extracted by mini-css-extract-plugin
export default {"contentByIdContainer":"wI1aYedXew4B47cFdBTA-ModularContent-contentByIdContainer"};